import { http } from '@/plugins/http'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_INSURANCES,
  RECEIVING_INSURANCES,
  RECEIVE_INSURANCE_METADATA,
  RECEIVE_INSURANCE_FAILURE,
  SAVING_INSURANCE,
  SAVING_INSURANCE_FAILURE,
  UPDATING_INSURANCE,
  UPDATING_INSURANCE_FAILURE,
  DELETE_INSURANCE,
  DELETING_INSURANCE,
  DELETING_INSURANCE_FAILURE,
  INCREMENT_INSURANCE_COUNT,
  CLEAR_INSURANCE_STATE,
  RESET_INSURANCE_META,
  CLEAR_STATE
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import handleXHRError from '@/utils/helpers/HandleXHRError'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const insuranceSchema = new schema.Entity('insurances')
const insuranceListSchema = new schema.Array(insuranceSchema)

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  saveFailure: null,
  receivingData: false,
  receiveDataFailure: false,
  updating: null,
  updateFailure: null,
  deleting: false,
  deleteFailure: null
}

const actions = {
  // Deprecated
  fetchInsurancesWithQuery (store, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_INSURANCES, true)
    return http.get(buildUrlWithQuery('insurances', query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        this.commit(RECEIVING_INSURANCES, false)
        this.commit(RESET_INSURANCE_META)
        if (!r.hasOwnProperty('results')) return this.commit(RECEIVE_INSURANCE_FAILURE, 'Error fetching insurance codes')
        const { results, next, previous, count } = r
        const { entities, result } = normalize(results, insuranceListSchema)
        this.commit(RECEIVE_INSURANCES, { data: entities.insurances })
        this.commit(RECEIVE_INSURANCE_METADATA, { next, previous, count, result: result.length })
        return { query, count, entities }
      })
      .catch(e => {
        this.commit(RECEIVING_INSURANCES, false)
        this.commit(RECEIVE_INSURANCE_FAILURE, handleXHRError(e))
      })
  }
}

const getters = {
  getInsurances: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllInsurances: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getInsuranceMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getInsuranceById: (state) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getInsuranceFetchStatus: (state) => {
    return state.receivingData
  },
  getInsuranceSaveStatus: (state) => {
    return state.saving
  },
  getInsuranceUpdateStatus: (state) => {
    return state.updating
  },
  getInsuranceDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_INSURANCES] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_INSURANCES] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_INSURANCE_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [SAVING_INSURANCE] (state, payload) {
    state.saving = payload
  },
  [SAVING_INSURANCE_FAILURE] (state, payload) {
    state.saveFailure = payload
  },
  [UPDATING_INSURANCE] (state, payload) {
    state.updating = payload
  },
  [UPDATING_INSURANCE_FAILURE] (state, payload) {
    const { id, err } = payload
    state.updateFailure = { id, err }
  },
  [DELETE_INSURANCE] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_INSURANCE] (state, payload) {
    state.deleting = payload
  },
  [DELETING_INSURANCE_FAILURE] (state, payload) {
    const { id, err } = payload
    state.deleteFailure = { id, err }
  },
  [INCREMENT_INSURANCE_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_INSURANCE_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_INSURANCE_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_INSURANCE_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
